import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@front-activerse/common-components';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import type { UnifiedMealData } from '../types';

const DescribeManualMealContainer: React.FC<{ fromUserMeals?: boolean }> = ({ fromUserMeals }) => {
  const navigate = useNavigate();
  const {
    consts: { APP_BRAND },
  } = useAppContext();

  let PLACEHOLDER_IMAGE_URL = '';

  switch (APP_BRAND) {
    case 'dtba':
      PLACEHOLDER_IMAGE_URL =
        'https://fra1.digitaloceanspaces.com/dl-space/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'radiance':
      PLACEHOLDER_IMAGE_URL =
        'https://radiance.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'resilient':
      PLACEHOLDER_IMAGE_URL =
        'https://resilient.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'shestrong':
      PLACEHOLDER_IMAGE_URL =
        'https://shestrong.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'raize':
      PLACEHOLDER_IMAGE_URL =
        'https://raize.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'oxy':
      PLACEHOLDER_IMAGE_URL =
        'https://oxy.fra1.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    case 'hashimoto':
      PLACEHOLDER_IMAGE_URL =
        'https://hashimoto.fra1.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
      break;
    default:
      PLACEHOLDER_IMAGE_URL =
        'https://fra1.digitaloceanspaces.com/dl-space/tracker/tracker_meal.placeholder.jpg';
      break;
  }

  const createManualMealData = (dietMealId: number): UnifiedMealData => ({
    id: dietMealId,
    name: '',
    kcal: 0,
    macro: {
      protein: { grams: 0 },
      fat: { grams: 0 },
      carbohydrates: { grams: 0 },
    },
    preparationImageUrl: PLACEHOLDER_IMAGE_URL,
    sourceType: 'manual',
    ingredients: [],
    portions: 1,
    isFromBaseMeal: false,
  });

  useEffect(() => {
    sessionStorage.setItem('tracker_depth', '1');
    const dietMealId = Math.floor(Math.random() * 1000000000);
    const mealData = createManualMealData(dietMealId);

    if (fromUserMeals) {
      navigate(`/meals/user-meals/describe-meal/meal-details/${dietMealId}`, {
        state: { mealData, requestId: null, timestamp: Date.now() },
        replace: true,
      });
    } else {
      navigate(`/tracker/describe-meal/meal-details/${dietMealId}`, {
        state: { mealData, requestId: null, timestamp: Date.now() },
        replace: true,
      });
    }
  }, [navigate, fromUserMeals]);

  return <UniversalPlaceholder titleBar="tracker.logMeal.navbarTitle" />;
};

export default DescribeManualMealContainer;
